// The server to land on when navigating from a server group scope to a narrower scope that requires a current server.
// A server group has a computed default (fallbackServerHumanId).
// A cluster-based server group resolves to the primary of that group (primaryServerHumanId).
export const defaultServerHumanId = (group: {
  primaryServerHumanId?: string | null;
  fallbackServerHumanId?: string | null;
}): string | null =>
  group.primaryServerHumanId ?? group.fallbackServerHumanId ?? null;
